var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	7975: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(8143); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	6045: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(758); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	4789: {
		fallback: function() { return __webpack_require__.e(144).then(function() { return function() { return __webpack_require__(5144); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.3.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [7975,6045,4789];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		4789
	],
	"789": [
		4789
	],
	"792": [
		7975,
		6045
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}